import { render, staticRenderFns } from "./modalEliminacionProductos.vue?vue&type=template&id=61a12993"
import script from "./modalEliminacionProductos.vue?vue&type=script&lang=js"
export * from "./modalEliminacionProductos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports